var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticClass:"multi-uploader",attrs:{"action":"#","accept":"image/*","on-change":_vm.handleAvatarChange,"on-remove":_vm.removeImg,"auto-upload":false,"list-type":"picture-card","multiple":"","file-list":_vm.list}},[_c('div',{staticClass:"addbox"},[_c('i',{staticClass:"el-icon-plus"}),_c('div',[_vm._v(_vm._s(_vm.uploadText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }